import axios from "axios";
import store from "@/store";
import { API_START_LOADING, API_FINISH_LOADING } from "@/store/mutations.type";

const Api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})

Api.interceptors.request.use(
  (config) => {
    store.commit(API_START_LOADING);
    return config;
  },
  (error) => {
    store.commit(API_FINISH_LOADING);
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  (response) => {
    store.commit(API_FINISH_LOADING);
    return response;
  },
  (error) => {
    store.commit(API_FINISH_LOADING);
    return Promise.reject(error);
  }
);

export { Api };
